import { ReactElement, useCallback, useEffect, useState } from 'react';

import { AxiosResultDefaultError } from '../../../api/request';
import DisplayError from '../../../components/info/DisplayError';
import Loading from '../../../components/info/Loading';
import { useLoadingState } from '../../../hooks/useLoadingState';
import { getCurriculumProgress } from '../requests';
import {
  CurriculumProgressBase,
  CurriculumProgressBaseResponse,
} from '../types/progress';

export interface BaseLoaderProps {
  studyPlanEnrollmentId: number | string;
  children: (props: CurriculumProgressBase) => ReactElement;
}

export default function BaseLoader({
  studyPlanEnrollmentId,
  children,
}: BaseLoaderProps) {
  const { loading, setLoading } = useLoadingState();

  const [data, setData] = useState<CurriculumProgressBaseResponse>();
  const [error, setError] = useState<AxiosResultDefaultError>();

  /* Función que se llama cuando se monta el componente. Trae la info utilizada en la vista */
  const load = useCallback(async () => {
    setLoading(true);

    const response = await getCurriculumProgress(studyPlanEnrollmentId);

    if (response.data) {
      setData(response.data);
      setError(undefined);
    }
    if (response.error) {
      setError(response.error);
    }
    setLoading(false);
  }, [setLoading, studyPlanEnrollmentId]);

  useEffect(() => {
    load();
  }, [load]);

  if (error) {
    return (
      <DisplayError
        insideCard
        textBody={error.code}
        retryAction={load}
        loadingAction={loading}
      />
    );
  }

  if (loading) {
    return <Loading insideCard />;
  }

  if (!data) {
    return (
      <DisplayError
        insideCard
        textBody="Data no cargada"
        retryAction={load}
        loadingAction={loading}
      />
    );
  }

  return children({
    ...data,
    periodActive: Boolean(data?.periodActive),
  });
}
